(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/personal-info.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/personal-info.js');
"use strict";


const _svs$tickets_giftshop = svs.tickets_giftshop.gift.giftform.components,
  NameInput = _svs$tickets_giftshop.NameInput,
  GreetingsInput = _svs$tickets_giftshop.GreetingsInput,
  PersonalGreetingInput = _svs$tickets_giftshop.PersonalGreetingInput;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.constants.names,
  NAME = _svs$tickets_giftshop2.NAME,
  GREETING = _svs$tickets_giftshop2.GREETING,
  PERSONAL_GREETING = _svs$tickets_giftshop2.PERSONAL_GREETING;
const GREETINGS_MAX = svs.tickets_giftshop.constants.form.GREETINGS_MAX;
const PersonalInfo = React.forwardRef((_ref, ref) => {
  let onInputChange = _ref.onInputChange,
    personalGreeting = _ref.personalGreeting,
    name = _ref.name,
    greeting = _ref.greeting,
    _ref$greetingMaxLengt = _ref.greetingMaxLength,
    greetingMaxLength = _ref$greetingMaxLengt === void 0 ? GREETINGS_MAX : _ref$greetingMaxLengt;
  const header = 'Skriv en hälsning';
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "f-body"
  }, React.createElement("h2", {
    className: "tg-form-header h2 u-text-center",
    ref: ref
  }, header), React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(PersonalGreetingInput, {
    name: PERSONAL_GREETING,
    onInputChange: onInputChange,
    value: personalGreeting
  }), React.createElement(NameInput, {
    name: NAME,
    onChange: onInputChange,
    value: name
  }), React.createElement(GreetingsInput, {
    maxLength: greetingMaxLength,
    name: GREETING,
    onChange: onInputChange,
    value: greeting
  }))));
});
svs.tickets_giftshop.gift.giftform.components.PersonalInfo = PersonalInfo;

 })(window);